import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { ONBOARDING_CSV_REPORT } from 'services/dataService/resources';
import { useEffect } from 'react';
import { showResult } from 'infrastructure/hooks/utils';

import type { RpmStatuses } from 'infrastructure/enums';
import type { IRpmOnboardingStatusReportFilters } from 'infrastructure/interfaces';

interface ISendReportResponse {
  response: string;
}

const mutationFn = async (postData: IRpmOnboardingStatusReportFilters) => {
  let requestStatus = postData.status;
  if (!postData.status || postData.status === null) {
    requestStatus = 'only_onboarding_flow' as RpmStatuses;
  }

  const { error, data } = await dataService.createOne<ISendReportResponse>(
    ONBOARDING_CSV_REPORT,
    {
      childClinic: postData.childClinic,
      clinicGuid: postData.clinicGuid?.length ? postData.clinicGuid : undefined,
      doctorGuids: postData.doctorGuid?.length
        ? postData.doctorGuid
        : undefined,
      patientGuid: postData.patientGuid,
      status: requestStatus,
    },
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useSendReport = () => {
  const { mutate, data, isLoading, error } = useMutation<
    ISendReportResponse | undefined,
    string | undefined,
    IRpmOnboardingStatusReportFilters
  >({
    mutationFn,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { sendReport: mutate, sendData: data, sendLoading: isLoading };
};
